import { jsx as e, jsxs as n, Fragment as W } from "react/jsx-runtime";
import { useState as h, useRef as _, useEffect as K } from "react";
import { useQueryClient as ir, useQuery as G, QueryClient as ar, QueryClientProvider as lr } from "@tanstack/react-query";
import { listPortalOrders as cr, getPortalOrder as or, getOrderOperationAvailability as We, getOrderCommandStatus as je, listSourceOrderAssets as Me, ApiError as I, downloadSourceOrderAsset as sr, getOrderPolicy as Ye, OrderMutationPolicySchema as dr, setOrderMutationPolicy as ur, setOrderPolicy as hr } from "@dss/api-client";
import { Banner as Y, Button as g, Input as pr, Card as Q } from "@dss/design-system";
function ze(t, l = 0) {
  if (typeof t != "string" || !/^-?\d+(\.\d+)?$(?![\s\S])/.test(t))
    throw new Error("Некорректное десятичное значение");
  const [a = "0", u = ""] = t.split("."), i = a.startsWith("-"), E = (i ? a.slice(1) : a).replace(/^0+(?=\d)/, ""), T = u.replace(/0+$/, ""), D = i && (E !== "0" || T !== "") ? "−" : "", P = E.replace(/\B(?=(\d{3})+(?!\d))/g, " "), o = T.padEnd(l, "0");
  return D + P + (o ? `,${o}` : "");
}
function ae(t, l) {
  const a = l === "RUB" ? "₽" : l.trim() ? l : "валюта не указана";
  return `${ze(t, 2)} ${a}`;
}
const ge = ["portal-order-list-context"];
function fr(t) {
  switch (t) {
    case "PENDING":
      return "Ожидает запроса 1С.";
    case "IN_FLIGHT":
      return "Команда выдана для обработки; результат ожидается.";
    case "WAITING":
      return "Обработка отложена; ожидается следующий запрос 1С.";
    case "RETRY":
      return "Ожидает повторной выдачи по запросу 1С.";
    case "DEAD_LETTER":
      return "Выдача остановлена; нужна проверка обмена.";
    case "APPLIED":
      return "Выдача завершена со статусом применения; подтверждение проверяется отдельно.";
    case "REJECTED":
      return "Выдача завершена со статусом отказа; подтверждение проверяется отдельно.";
    case "CONFLICT":
      return "Выдача завершена со статусом конфликта; подтверждение проверяется отдельно.";
    default:
      return "Состояние очереди не распознано. Проверьте данные повторно.";
  }
}
const mr = {
  permission_missing: "у вас нет права на эту операцию",
  policy_disabled: "операция отключена в настройках дистрибьютора",
  source_snapshot_missing: "подтверждённые данные заказа из 1С ещё не получены",
  mutation_pending: "предыдущий запрос изменения или отмены ещё не завершён",
  source_window_unverified: "правила обработки в 1С ещё не подтверждены",
  operation_adapter_not_verified: "поддержка операции при обмене с 1С ещё не подтверждена"
};
function Dr(t) {
  return /* @__PURE__ */ e(gr, { ...t }, `${t.identity}:${t.orderId ?? "list"}`);
}
function gr({ api: t, token: l, identity: a, viewerRole: u, orderId: i, onOpen: E, onBack: T }) {
  var Se, qe, Le, ke, xe, $e, Ue, Be, _e, Ke, Qe;
  const D = u === "DISTRIBUTOR_OWNER" || u === "DISTRIBUTOR_EMPLOYEE", P = D ? "Проверьте заказ и причину отказа или конфликта в 1С." : "Обратитесь к менеджеру дистрибьютора.", o = ir(), [c] = h(() => {
    const r = o.getQueryData(ge);
    return (r == null ? void 0 : r.identity) === a ? r : void 0;
  }), [f, z] = h((c == null ? void 0 : c.draft) ?? ""), [F, S] = h((c == null ? void 0 : c.search) ?? ""), [C, N] = h((c == null ? void 0 : c.page) ?? 0), [x, j] = h((c == null ? void 0 : c.originFilter) ?? ""), [M, le] = h((c == null ? void 0 : c.pendingFilter) ?? ""), [p, $] = h((c == null ? void 0 : c.dateFrom) ?? ""), [v, ce] = h((c == null ? void 0 : c.dateTo) ?? ""), [X, oe] = h(""), [A, Pe] = h((c == null ? void 0 : c.filters) ?? {}), [se, Fe] = h(!1), ye = _(null);
  K(() => {
    var r;
    X && se && ((r = ye.current) == null || r.focus());
  }, [X, se]), K(() => {
    const r = o.getQueryData(ge);
    r && r.identity !== a && o.removeQueries({ queryKey: ge }), i === void 0 && o.setQueryData(
      ge,
      { identity: a, draft: f, search: F, page: C, originFilter: x, pendingFilter: M, dateFrom: p, dateTo: v, filters: A }
    );
  }, [o, a, i, f, F, C, x, M, p, v, A]);
  const de = !!(F || Object.keys(A).length), Xe = [
    ...F ? [`Номер: ${F}`] : [],
    ...A.origin ? [{
      PORTAL: "Созданы на портале",
      SOURCE: "Созданы в 1С",
      UNKNOWN: "Происхождение не определено"
    }[A.origin]] : [],
    ...A.pending === void 0 ? [] : [A.pending ? "Есть неопределённые связи" : "Связи определены"],
    ...A.dateFrom || A.dateTo ? [`Период: ${A.dateFrom ? Je(A.dateFrom) : "без даты начала"} — ${A.dateTo ? Je(A.dateTo, !0) : "без даты окончания"}`] : []
  ], [ve, be] = h(null), [Ne, Ae] = h(!1), Z = _({ token: l, generation: 0 });
  Z.current.token !== l && (Z.current = { token: l, generation: Z.current.generation + 1 });
  const [Ee, ue] = h(null), he = _(null), re = _(!0), H = _(/* @__PURE__ */ new Set());
  K(() => {
    re.current = !0;
    const r = H.current;
    return () => {
      var d;
      re.current = !1, Z.current.generation += 1, (d = he.current) == null || d.abort(), r.forEach((b) => URL.revokeObjectURL(b));
    };
  }, []);
  const ne = i === void 0 || Number.isSafeInteger(i) && i > 0, U = G({
    queryKey: ["portal-orders", a, F, C, A],
    queryFn: ({ signal: r }) => cr(t, l, { search: F, page: C, ...A }, r),
    enabled: i === void 0,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), y = G({
    queryKey: ["portal-order", a, i],
    queryFn: ({ signal: r }) => or(t, l, i, r),
    enabled: i !== void 0 && ne,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), te = i === void 0 ? U : y, q = G({
    queryKey: ["portal-order-operations", a, i],
    queryFn: ({ signal: r }) => We(t, l, i, r),
    enabled: i !== void 0 && ne && !!y.data && !y.isError,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4,
    gcTime: 0
  });
  K(() => () => {
    o.removeQueries({ queryKey: ["portal-order-operations", a, i], exact: !0 });
  }, [o, a, i]);
  const L = G({
    queryKey: ["portal-order-command", a, i],
    queryFn: ({ signal: r }) => je(t, l, i, r),
    enabled: i !== void 0 && ne && !!y.data && !y.isError,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), O = (Se = y.data) == null ? void 0 : Se.sourceConfirmation, J = O ? JSON.stringify([
    (qe = y.data) == null ? void 0 : qe.order.externalId,
    O.connectionId,
    O.generation,
    O.revision,
    O.snapshotId
  ]) : null, R = G({
    queryKey: [
      "portal-order-source-assets",
      a,
      i,
      J
    ],
    queryFn: ({ signal: r }) => Me(t, l, i, r),
    enabled: i !== void 0 && ne && !y.isError && ((Le = y.data) == null ? void 0 : Le.attachmentsAllowed) === !0,
    retry: !1,
    staleTime: 0,
    refetchInterval: 3e4
  }), De = ve instanceof I && [401, 403, 404].includes(ve.status), Ze = ((ke = y.data) == null ? void 0 : ke.attachmentsAllowed) === !0 && R.error instanceof I && [401, 403, 404].includes(R.error.status), er = L.error instanceof I && [401, 403, 404].includes(L.error.status), Oe = q.error instanceof I && [401, 403, 404].includes(q.error.status), pe = te.isError || De || Ze || er || Oe, Ce = O ? (R.data ?? []).filter((r) => {
    var d;
    return r.connectionId === O.connectionId && r.generation === O.generation && r.revision === O.revision && r.sourceOrderId === ((d = y.data) == null ? void 0 : d.order.externalId);
  }) : [], fe = !!((xe = R.data) != null && xe.length && Ce.length !== R.data.length), we = _(!1);
  we.current = !pe && !R.isError && !fe && J !== null && (($e = y.data) == null ? void 0 : $e.attachmentsAllowed) === !0;
  const Te = _(J);
  Te.current = J, K(() => () => {
    var r;
    (r = he.current) == null || r.abort(), H.current.forEach((d) => URL.revokeObjectURL(d)), H.current.clear();
  }, [J]), K(() => {
    var r, d;
    (pe || fe || ((r = y.data) == null ? void 0 : r.attachmentsAllowed) === !1) && ((d = he.current) == null || d.abort(), H.current.forEach((b) => URL.revokeObjectURL(b)), H.current.clear(), ue(null));
  }, [pe, fe, (Ue = y.data) == null ? void 0 : Ue.attachmentsAllowed]), K(() => {
    ue(null);
  }, [J]);
  async function rr(r, d) {
    if (i === void 0 || Ee !== null || !we.current || !Ce.some((V) => V.id === r)) return;
    const b = J, k = new AbortController();
    he.current = k, ue(r), be(null);
    try {
      const V = await sr(t, l, i, r, k.signal);
      if (k.signal.aborted || !we.current || Te.current !== b) return;
      const B = URL.createObjectURL(V);
      H.current.add(B);
      const ie = document.createElement("a");
      ie.href = B, ie.download = d ?? `order-${i}-${r}`, document.body.append(ie), ie.click(), ie.remove(), window.setTimeout(() => {
        URL.revokeObjectURL(B), H.current.delete(B);
      }, 1e3);
    } catch (V) {
      k.signal.aborted || be(V);
    } finally {
      k.signal.aborted || ue(null);
    }
  }
  async function nr() {
    if (i === void 0 || Ne) return;
    const r = ++Z.current.generation, d = () => re.current && Z.current.generation === r;
    Ae(!0);
    try {
      const b = await y.refetch();
      if (!d() || b.isError || !b.data) return;
      const k = b.data.sourceConfirmation, V = k ? JSON.stringify([
        b.data.order.externalId,
        k.connectionId,
        k.generation,
        k.revision,
        k.snapshotId
      ]) : null;
      if (await Promise.all([
        o.cancelQueries({ queryKey: ["portal-order-command", a, i], exact: !0 }),
        o.cancelQueries({ queryKey: ["portal-order-operations", a, i], exact: !0 }),
        o.cancelQueries({ queryKey: ["portal-order-source-assets", a, i, V], exact: !0 })
      ]), !d()) return;
      await Promise.all([
        o.fetchQuery({
          queryKey: ["portal-order-command", a, i],
          queryFn: ({ signal: B }) => je(t, l, i, B),
          staleTime: 0,
          retry: !1
        }),
        o.fetchQuery({
          queryKey: ["portal-order-operations", a, i],
          queryFn: ({ signal: B }) => We(t, l, i, B),
          staleTime: 0,
          retry: !1
        }),
        ...b.data.attachmentsAllowed ? [o.fetchQuery({
          queryKey: ["portal-order-source-assets", a, i, V],
          queryFn: ({ signal: B }) => Me(t, l, i, B),
          staleTime: 0,
          retry: !1
        })] : []
      ]), d() && o.getQueryData(["portal-order", a, i]) === b.data && be(null);
    } catch {
    } finally {
      re.current && Ae(!1);
    }
  }
  if (!ne) return /* @__PURE__ */ e(Y, { variant: "danger", body: "Некорректный номер ссылки на заказ." });
  if (pe) return /* @__PURE__ */ n("section", { className: "portal-orders", children: [
    /* @__PURE__ */ e("h1", { children: "Заказы" }),
    /* @__PURE__ */ e(Y, { variant: "danger", body: te.error instanceof I && te.error.status === 404 ? "Заказ не найден или больше не входит в вашу область доступа." : "Не удалось подтвердить текущий доступ или получить свежие данные. Прежние данные скрыты." }),
    /* @__PURE__ */ e(g, { disabled: Ne, onClick: () => {
      var r;
      if (De) {
        nr();
        return;
      }
      te.refetch(), (r = y.data) != null && r.attachmentsAllowed && R.refetch(), i !== void 0 && L.refetch(), i !== void 0 && q.refetch();
    }, children: "Проверить снова" }),
    i !== void 0 && /* @__PURE__ */ e(g, { onClick: T, children: "К списку заказов" })
  ] });
  if (te.isPending && i !== void 0) return /* @__PURE__ */ e("p", { role: "status", children: "Загружаем текущие заказы…" });
  if (i === void 0) return /* @__PURE__ */ n("section", { className: "portal-orders", children: [
    /* @__PURE__ */ n("header", { children: [
      /* @__PURE__ */ e("p", { className: "portal-orders-eyebrow", children: "Ежедневная работа" }),
      /* @__PURE__ */ e("h1", { children: "Заказы" }),
      /* @__PURE__ */ e("p", { children: "Только заказы в вашей текущей области доступа. Статусы и обработка — на стороне 1С." })
    ] }),
    /* @__PURE__ */ n("form", { className: "portal-orders-search", onSubmit: (r) => {
      var d;
      if (r.preventDefault(), p && v && p > v) {
        Fe(!0), oe("Дата начала не может быть позже даты окончания."), se && ((d = ye.current) == null || d.focus());
        return;
      }
      oe(""), S(f.trim()), N(0), Pe({
        ...x ? { origin: x } : {},
        ...M ? { pending: M === "true" } : {},
        ...p ? { dateFrom: He(p) } : {},
        ...v ? { dateTo: He(v, !0) } : {}
      });
    }, children: [
      /* @__PURE__ */ n("div", { className: "portal-orders-search-row", children: [
        /* @__PURE__ */ n("label", { htmlFor: "portal-order-search", children: [
          "Номер заказа",
          /* @__PURE__ */ e(
            pr,
            {
              id: "portal-order-search",
              name: "orderNumber",
              placeholder: "Например, DS2B-123",
              maxLength: 160,
              value: f,
              onChange: (r) => z(r.target.value)
            }
          )
        ] }),
        /* @__PURE__ */ e(g, { type: "submit", variant: "primary", children: "Найти" })
      ] }),
      /* @__PURE__ */ n(
        "details",
        {
          className: "portal-orders-filters",
          open: se,
          onToggle: (r) => Fe(r.currentTarget.open),
          children: [
            /* @__PURE__ */ e("summary", { children: "Фильтры: источник, связи и период" }),
            /* @__PURE__ */ n("div", { className: "portal-orders-filter-fields", children: [
              /* @__PURE__ */ n("label", { children: [
                "Происхождение",
                /* @__PURE__ */ n("select", { value: x, onChange: (r) => j(r.target.value), children: [
                  /* @__PURE__ */ e("option", { value: "", children: "Все заказы" }),
                  /* @__PURE__ */ e("option", { value: "PORTAL", children: "Созданы на портале" }),
                  /* @__PURE__ */ e("option", { value: "SOURCE", children: "Созданы в 1С" }),
                  /* @__PURE__ */ e("option", { value: "UNKNOWN", children: "Происхождение не определено" })
                ] })
              ] }),
              /* @__PURE__ */ n("label", { children: [
                "Связи заказа",
                /* @__PURE__ */ n("select", { value: M, onChange: (r) => le(r.target.value), children: [
                  /* @__PURE__ */ e("option", { value: "", children: "Все" }),
                  /* @__PURE__ */ e("option", { value: "true", children: "Есть неопределённые связи" }),
                  /* @__PURE__ */ e("option", { value: "false", children: "Связи определены" })
                ] })
              ] }),
              /* @__PURE__ */ n("label", { children: [
                "Дата заказа с",
                /* @__PURE__ */ e("input", { type: "date", value: p, onChange: (r) => $(r.target.value) })
              ] }),
              /* @__PURE__ */ n("label", { children: [
                "Дата заказа по",
                /* @__PURE__ */ e(
                  "input",
                  {
                    ref: ye,
                    type: "date",
                    value: v,
                    "aria-invalid": !!X,
                    "aria-describedby": X ? "order-filter-error" : void 0,
                    onChange: (r) => {
                      ce(r.target.value), oe("");
                    }
                  }
                )
              ] })
            ] }),
            X && /* @__PURE__ */ e("p", { id: "order-filter-error", role: "alert", children: X }),
            /* @__PURE__ */ e("p", { className: "portal-orders-filter-hint", children: "Период включает обе даты в часовом поясе вашего устройства. Если дата документа не передана, используется дата появления заказа на портале. Неопределённые связи — не статус обработки в 1С." }),
            /* @__PURE__ */ e(g, { type: "submit", children: "Применить фильтры" })
          ]
        }
      ),
      (de || f || x || M || p || v) && /* @__PURE__ */ n("div", { className: "portal-orders-applied", children: [
        de && /* @__PURE__ */ n("p", { role: "status", children: [
          "Применено: ",
          Xe.join(" · ")
        ] }),
        /* @__PURE__ */ e(g, { onClick: () => {
          z(""), S(""), N(0), Pe({}), j(""), le(""), $(""), ce(""), oe("");
        }, children: "Сбросить" })
      ] })
    ] }),
    /* @__PURE__ */ n("div", { className: "portal-orders-toolbar", children: [
      /* @__PURE__ */ n("span", { children: [
        "Найдено: ",
        ((Be = U.data) == null ? void 0 : Be.totalElements) ?? "…"
      ] }),
      /* @__PURE__ */ e(g, { loading: U.isFetching, onClick: () => void U.refetch(), children: "Обновить" })
    ] }),
    U.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Загружаем текущие заказы…" }) : U.data.content.length ? /* @__PURE__ */ e("ul", { className: "portal-order-cards", children: U.data.content.map((r) => /* @__PURE__ */ e("li", { children: /* @__PURE__ */ n(Q, { padding: "lg", children: [
      /* @__PURE__ */ n("div", { className: "portal-order-card-top", children: [
        /* @__PURE__ */ n("div", { children: [
          /* @__PURE__ */ e("h2", { children: r.documentNumber ?? `Заказ №${r.id}` }),
          /* @__PURE__ */ n("p", { children: [
            ee(r.documentDate ?? r.createdAt),
            " · ",
            Ve(r)
          ] })
        ] }),
        /* @__PURE__ */ e("strong", { children: ae(r.totalAmount, r.currency) })
      ] }),
      /* @__PURE__ */ e("p", { className: "portal-order-status", children: Ie(r) }),
      /* @__PURE__ */ e("p", { children: r.currentTradepointName ?? `Точка №${r.tradepointId ?? "не определена"}` }),
      /* @__PURE__ */ e("p", { children: r.deliveryAddress ?? "Адрес доставки в заказе не указан" }),
      /* @__PURE__ */ n("p", { children: [
        "Плательщик: ",
        r.currentPayerName ?? "Не определён"
      ] }),
      /* @__PURE__ */ n(g, { onClick: () => E(r.id), children: [
        "Открыть заказ ",
        r.documentNumber ?? r.id
      ] })
    ] }) }, r.id)) }) : /* @__PURE__ */ n(Q, { padding: "lg", children: [
      /* @__PURE__ */ e("h2", { children: de ? "Ничего не найдено" : "Пока нет доступных заказов" }),
      /* @__PURE__ */ e("p", { children: de ? "Измените условия или сбросьте фильтры." : "Здесь появятся созданные заказы. История из 1С доступна клиентам только если её включил дистрибьютор и настроены точные связи точки и плательщика." })
    ] }),
    U.data && /* @__PURE__ */ n("nav", { className: "portal-orders-toolbar", "aria-label": "Страницы заказов", children: [
      /* @__PURE__ */ e(g, { disabled: C === 0, onClick: () => N(C - 1), children: "Предыдущая" }),
      /* @__PURE__ */ n("span", { children: [
        "Страница ",
        C + 1,
        " из ",
        Math.max(1, U.data.totalPages)
      ] }),
      /* @__PURE__ */ e(g, { disabled: C + 1 >= U.data.totalPages, onClick: () => N(C + 1), children: "Следующая" })
    ] })
  ] });
  const w = y.data, m = w.order, s = (_e = L.data) == null ? void 0 : _e.command, me = !!(s != null && s.outcome && s.receivedAt), Re = me && (s == null ? void 0 : s.outcome) === "APPLIED" && O && O.connectionId === s.connectionId && O.generation === s.generation && m.externalId === s.sourceOrderId && s.resultRevision !== null && BigInt(O.revision) >= BigInt(s.resultRevision), tr = async () => {
    var d;
    const r = await y.refetch();
    r.isError || !re.current || await Promise.all([
      L.refetch(),
      q.refetch(),
      ...(d = r.data) != null && d.attachmentsAllowed ? [R.refetch()] : []
    ]);
  };
  return /* @__PURE__ */ n("section", { className: "portal-orders", children: [
    /* @__PURE__ */ e(g, { onClick: T, children: "← К заказам" }),
    /* @__PURE__ */ n("header", { children: [
      /* @__PURE__ */ e("p", { className: "portal-orders-eyebrow", children: Ve(m) }),
      /* @__PURE__ */ e("h1", { children: m.documentNumber ?? `Заказ №${m.id}` }),
      /* @__PURE__ */ n("p", { children: [
        ee(m.documentDate ?? m.createdAt),
        " · ",
        Ie(m)
      ] }),
      /* @__PURE__ */ n("strong", { children: [
        "Итого: ",
        ae(m.totalAmount, m.currency)
      ] })
    ] }),
    /* @__PURE__ */ n("section", { "aria-label": "Состояние заказа", children: [
      L.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось обновить состояние обработки. Повторите обновление данных." }) : me && (s == null ? void 0 : s.outcome) !== "APPLIED" ? /* @__PURE__ */ e(
        Y,
        {
          variant: "warning",
          body: `${(s == null ? void 0 : s.outcome) === "REJECTED" ? "Запрос отклонён." : D ? "Возник конфликт запроса." : "Требуется проверка менеджера: возник конфликт запроса."} ${P} Автоматическая повторная отправка не выполняется.`
        }
      ) : me && (s == null ? void 0 : s.outcome) === "APPLIED" && !Re ? /* @__PURE__ */ e("p", { role: "status", children: "Обработка завершена. Ожидаем обновлённые данные заказа." }) : !w.sourceConfirmation && /* @__PURE__ */ e("p", { role: "status", children: m.origin === "PORTAL" ? "Заказ сохранён. Ожидаем подтверждение дистрибьютора." : "Исторический заказ. Актуальное состояние пока не подтверждено." }),
      /* @__PURE__ */ e(
        g,
        {
          loading: y.isFetching || L.isFetching || q.isFetching || R.isFetching,
          onClick: () => void tr(),
          children: "Обновить данные"
        }
      )
    ] }),
    m.pending && /* @__PURE__ */ e(Y, { variant: "warning", body: "Не все источниковые связи заказа определены. Менеджеру нужно проверить данные обмена." }),
    q.isError && !Oe && /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось проверить ограничения. Изменение и отмена на портале недоступны." }),
    /* @__PURE__ */ n(Q, { padding: "lg", children: [
      /* @__PURE__ */ e("h2", { children: "Состав заказа" }),
      w.lines.length ? /* @__PURE__ */ e("ol", { className: "portal-order-lines", children: w.lines.map((r) => {
        var d;
        return /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ n("div", { children: [
            /* @__PURE__ */ e("strong", { children: r.name ?? `Товар 1С ${r.skuExternalId}` }),
            /* @__PURE__ */ n("p", { children: [
              "Артикул: ",
              r.article ?? "не указан"
            ] })
          ] }),
          /* @__PURE__ */ n("div", { children: [
            "Количество: ",
            ze(r.quantity),
            /* @__PURE__ */ e("p", { children: (d = r.unitName) != null && d.trim() ? r.unitName : /* @__PURE__ */ n(W, { children: [
              "Название единицы в заказе не указано",
              r.unitCode ? ` · код ${r.unitCode}` : ""
            ] }) }),
            /* @__PURE__ */ n("p", { children: [
              "По ",
              ae(r.price, m.currency)
            ] })
          ] }),
          /* @__PURE__ */ e("strong", { children: ae(r.lineTotal, m.currency) })
        ] }, r.id);
      }) }) : /* @__PURE__ */ e("p", { children: "Строки ещё не получены." }),
      /* @__PURE__ */ n("p", { className: "portal-order-total", children: [
        "Итого по заказу: ",
        /* @__PURE__ */ e("strong", { children: ae(m.totalAmount, m.currency) })
      ] })
    ] }),
    /* @__PURE__ */ n(Q, { padding: "lg", children: [
      /* @__PURE__ */ e("h2", { children: "Доставка и плательщик" }),
      /* @__PURE__ */ n("dl", { children: [
        /* @__PURE__ */ e("dt", { children: "Торговая точка · текущее название" }),
        /* @__PURE__ */ e("dd", { children: m.currentTradepointName ?? "Не определена" }),
        /* @__PURE__ */ e("dt", { children: "Адрес в заказе" }),
        /* @__PURE__ */ e("dd", { children: m.deliveryAddress ?? "Не указан" }),
        /* @__PURE__ */ e("dt", { children: "Дата доставки" }),
        /* @__PURE__ */ e("dd", { children: m.deliveryDate ?? "Не указана" }),
        /* @__PURE__ */ e("dt", { children: "Плательщик · текущее название" }),
        /* @__PURE__ */ e("dd", { children: m.currentPayerName ?? "Не определён" }),
        /* @__PURE__ */ e("dt", { children: "Комментарий к заказу" }),
        /* @__PURE__ */ e("dd", { children: m.comment ?? "Нет комментария" })
      ] }),
      /* @__PURE__ */ e("p", { children: D ? "Необходимость изменения или отмены проверьте в 1С. На портале эти действия недоступны." : "Для изменения или отмены обратитесь к менеджеру дистрибьютора." })
    ] }),
    /* @__PURE__ */ n("details", { children: [
      /* @__PURE__ */ e("summary", { children: "Подробности обработки" }),
      !w.sourceConfirmation && /* @__PURE__ */ e("p", { children: "Подтверждённый снимок 1С ещё не получен. Данные заказа на портале — это не подтверждение отгрузки или резерва." }),
      /* @__PURE__ */ n(Q, { padding: "lg", children: [
        /* @__PURE__ */ e("h2", { children: "Результат отправки в 1С" }),
        !L.isPending && !L.isError && s && /* @__PURE__ */ n("p", { children: [
          "Очередь: ",
          fr(s.state),
          " Состояние выдачи не подтверждает применение заказа в 1С."
        ] }),
        L.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем результат команды…" }) : L.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось получить свежий результат команды. Прежний результат скрыт." }) : s ? me ? /* @__PURE__ */ n(W, { children: [
          /* @__PURE__ */ e("p", { children: s.outcome === "APPLIED" ? "1С сообщила: команда применена." : s.outcome === "REJECTED" ? "1С отклонила команду." : "1С сообщила о конфликте команды." }),
          /* @__PURE__ */ n("p", { children: [
            "Результат получен: ",
            ee(s.receivedAt)
          ] }),
          s.errorCode && /* @__PURE__ */ n("p", { children: [
            "Код результата: ",
            s.errorCode
          ] }),
          s.outcome === "APPLIED" && /* @__PURE__ */ e("p", { children: Re ? "Подтверждённый снимок этой или более новой ревизии получен." : "Ожидается подтверждённый снимок 1С для результата команды. Данные заказа пока не подтверждают этот результат." }),
          s.outcome !== "APPLIED" && /* @__PURE__ */ n("p", { children: [
            P,
            " Автоматическая повторная отправка не выполняется."
          ] }),
          /* @__PURE__ */ e("p", { children: "Результат команды, снимок заказа и PDF проверяются отдельно; применение команды не означает отгрузку." })
        ] }) : /* @__PURE__ */ e("p", { children: "Подтверждённый результат команды по новому протоколу ещё не получен. Техническое состояние отправки не доказывает принятие заказа в 1С." }) : /* @__PURE__ */ e("p", { children: "Для заказа нет команд портала." })
      ] }),
      /* @__PURE__ */ n(Q, { padding: "lg", children: [
        /* @__PURE__ */ e("h2", { children: "Обработка в 1С" }),
        /* @__PURE__ */ n("dl", { children: [
          /* @__PURE__ */ e("dt", { children: "Последнее получение данных" }),
          /* @__PURE__ */ e("dd", { children: w.sourceConfirmation ? ee(w.sourceConfirmation.receivedAt) : "Подтверждённый снимок ещё не получен" }),
          /* @__PURE__ */ e("dt", { children: "Ревизия источника" }),
          /* @__PURE__ */ e("dd", { children: ((Ke = w.sourceConfirmation) == null ? void 0 : Ke.revision) ?? "Не подтверждена" }),
          w.sourceConfirmation && /* @__PURE__ */ n(W, { children: [
            /* @__PURE__ */ e("dt", { children: "Поколение источника" }),
            /* @__PURE__ */ e("dd", { children: w.sourceConfirmation.generation }),
            /* @__PURE__ */ e("dt", { children: "Изменено в учётной системе" }),
            /* @__PURE__ */ e("dd", { children: w.sourceConfirmation.sourceModifiedAt ? ee(w.sourceConfirmation.sourceModifiedAt) : "Время не передано" })
          ] })
        ] }),
        w.sourceConfirmation && /* @__PURE__ */ e("p", { children: "Показан подтверждённый снимок из учётной системы. Он не означает отгрузку или резерв, если это не указано в статусе заказа." }),
        /* @__PURE__ */ e("h3", { children: "Изменение и отмена" }),
        q.isFetching || q.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем доступность операций…" }) : q.isError ? null : q.data && /* @__PURE__ */ n(W, { children: [
          /* @__PURE__ */ e("p", { children: "Изменение и отмена на портале пока недоступны: правила обработки в 1С и поддержка этих операций ещё не подтверждены." }),
          /* @__PURE__ */ n("details", { children: [
            /* @__PURE__ */ e("summary", { children: "Дополнительные ограничения для этого заказа" }),
            ["edit", "cancel"].map((r) => {
              const d = q.data[r].reasons.filter((b) => b !== "source_window_unverified" && b !== "operation_adapter_not_verified");
              return d.length > 0 && /* @__PURE__ */ n("p", { children: [
                /* @__PURE__ */ n("strong", { children: [
                  r === "edit" ? "Изменение" : "Отмена",
                  ":"
                ] }),
                " ",
                d.map((b) => mr[b]).join("; "),
                "."
              ] }, r);
            }),
            /* @__PURE__ */ e("p", { children: "Настройки портала сами по себе не включают обработку в 1С." })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ n("div", { className: "portal-order-detail-grid", children: [
      /* @__PURE__ */ n(Q, { padding: "lg", children: [
        /* @__PURE__ */ e("h2", { children: "Документы" }),
        w.attachmentsAllowed ? R.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем текущие PDF…" }) : R.isError ? /* @__PURE__ */ e("p", { role: "alert", children: "Не удалось проверить текущие PDF. Прежний список скрыт." }) : fe ? /* @__PURE__ */ e("p", { role: "status", children: "Данные заказа обновились. Обновите данные перед скачиванием документов." }) : (Qe = R.data) != null && Qe.length ? /* @__PURE__ */ e("ul", { children: Ce.map((r) => /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ n("details", { children: [
            /* @__PURE__ */ e("summary", { children: "Сведения о документе" }),
            /* @__PURE__ */ n("p", { children: [
              "Ревизия ",
              r.revision,
              " · шаблон ",
              r.templateId,
              ", версия ",
              r.templateVersion
            ] })
          ] }),
          /* @__PURE__ */ n(
            g,
            {
              loading: Ee === r.id,
              disabled: Ee !== null,
              onClick: () => void rr(r.id, r.fileName),
              children: [
                "Скачать ",
                r.fileName ?? "документ"
              ]
            }
          )
        ] }, r.id)) }) : /* @__PURE__ */ e("p", { children: "Документы пока не получены." }) : /* @__PURE__ */ e("p", { children: "Просмотр файлов вам не разрешён." }),
        !!ve && /* @__PURE__ */ e("p", { role: "alert", children: "Файл не получен. Проверьте соединение и повторите загрузку." })
      ] }),
      /* @__PURE__ */ n("details", { children: [
        /* @__PURE__ */ e("summary", { children: "История статусов" }),
        w.statusEvents.length ? /* @__PURE__ */ e("ol", { className: "portal-order-timeline", children: w.statusEvents.map((r) => /* @__PURE__ */ n("li", { children: [
          /* @__PURE__ */ e("strong", { children: r.statusTo }),
          " · ",
          ee(r.occurredAt),
          r.comment && /* @__PURE__ */ e("p", { children: r.comment })
        ] }, r.id)) }) : /* @__PURE__ */ e("p", { children: "Изменения статуса ещё не получены." })
      ] })
    ] })
  ] });
}
function Ve(t) {
  return { PORTAL: "Создан на портале", SOURCE: "Заказ из 1С", UNKNOWN: "История · происхождение не подтверждено" }[t.origin];
}
function Ie(t) {
  var l;
  return (l = t.sourceStatusName) != null && l.trim() ? t.sourceStatusName : t.origin === "PORTAL" && t.statusCode === "new_in_portal" ? "Сохранён на портале" : `Код статуса: ${t.statusCode}`;
}
function ee(t) {
  return new Date(t).toLocaleString("ru-RU");
}
function He(t, l = !1) {
  const a = /* @__PURE__ */ new Date(`${t}T00:00:00`);
  return l && a.setDate(a.getDate() + 1), a.toISOString();
}
function Je(t, l = !1) {
  const a = new Date(t);
  return l && a.setDate(a.getDate() - 1), a.toLocaleDateString("ru-RU");
}
function Or({ scope: t, children: l }) {
  return /* @__PURE__ */ e(yr, { children: l }, t);
}
function yr({ children: t }) {
  const [l] = h(() => new ar({ defaultOptions: {
    queries: { retry: 1, staleTime: 3e4, refetchOnWindowFocus: !1 },
    mutations: { retry: 0 }
  } })), a = _(!1);
  return K(() => (a.current = !0, () => {
    a.current = !1, queueMicrotask(() => {
      a.current || (l.cancelQueries(), l.clear());
    });
  }), [l]), /* @__PURE__ */ e(lr, { client: l, children: t });
}
const Ge = [
  ["clientEditAllowed", "Клиенты могут запрашивать изменение заказа"],
  ["clientCancelAllowed", "Клиенты могут запрашивать отмену заказа"],
  ["employeeEditAllowed", "Сотрудники дистрибьютора могут запрашивать изменение заказа"],
  ["employeeCancelAllowed", "Сотрудники дистрибьютора могут запрашивать отмену заказа"]
];
function vr({ api: t, token: l, identity: a }) {
  return /* @__PURE__ */ e(br, { api: t, token: l, identity: a }, a);
}
function br({ api: t, token: l, identity: a }) {
  const u = G({
    queryKey: ["portal-order-policy", a],
    queryFn: () => Ye(t, l),
    retry: !1,
    staleTime: 0
  }), [i, E] = h(null), [T, D] = h(null), [P, o] = h(!1), [c, f] = h(""), [z, F] = h(!1), [S, C] = h(!1), N = _(!0), x = _(!1);
  K(() => (N.current = !0, () => {
    N.current = !1;
  }), []);
  const j = dr.safeParse(u.data), M = (p, $, v, ce) => {
    T === null && D(ce), E({ ...i ?? v, [p]: $ }), F(!1);
  };
  async function le(p, $) {
    if (!(x.current || c || S || u.isFetching)) {
      x.current = !0, o(!0), F(!1);
      try {
        if (await ur(t, l, T ?? p.version, $), !N.current) return;
        E(null), D(null), F(!0);
      } catch (v) {
        if (!N.current) return;
        v instanceof I && [401, 403].includes(v.status) ? (C(!0), E(null), D(null)) : f(v instanceof I && v.status === 409 ? "Политика изменена в другой сессии. Ваш выбор сохранён; сравните его с текущими значениями." : "Результат сохранения не подтверждён. Ваш выбор сохранён; проверьте текущие значения перед новой попыткой.");
      } finally {
        N.current && (await u.refetch(), N.current && o(!1)), x.current = !1;
      }
    }
  }
  return /* @__PURE__ */ e("section", { className: "portal-mutation-policy", children: /* @__PURE__ */ n(Q, { padding: "lg", children: [
    /* @__PURE__ */ e("h2", { children: "Запросы изменения и отмены заказов" }),
    /* @__PURE__ */ e("p", { children: "Выберите, кому разрешено обращаться с такими запросами. По умолчанию все разрешения выключены." }),
    /* @__PURE__ */ e(Y, { variant: "info", body: "Разрешение не включает функцию: требуется поддержка подключённой 1С и проверка её точной сборки. Также действуют права сотрудника, доступ к заказу и его статус в 1С." }),
    S || u.isError ? /* @__PURE__ */ n(W, { children: [
      /* @__PURE__ */ e(Y, { variant: "danger", body: "Доступ или текущие настройки не подтверждены. Прежние значения скрыты." }),
      /* @__PURE__ */ e(g, { onClick: () => {
        u.refetch().then((p) => {
          N.current && !p.isError && C(!1);
        });
      }, children: "Проверить доступ и настройки" })
    ] }) : u.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем политику заказов…" }) : j.success ? /* @__PURE__ */ n(W, { children: [
      c && /* @__PURE__ */ e("p", { role: "alert", children: c }),
      z && /* @__PURE__ */ e("p", { role: "status", children: "Разрешения сохранены. Это не подтверждение готовности изменения и отмены заказов в 1С." }),
      c && /* @__PURE__ */ n(W, { children: [
        /* @__PURE__ */ e("ul", { "aria-label": "Сохранённые разрешения", children: Ge.map(([p, $]) => /* @__PURE__ */ n("li", { children: [
          $,
          ": ",
          j.data[p] ? "разрешено владельцем" : "запрещено владельцем"
        ] }, p)) }),
        /* @__PURE__ */ e(g, { disabled: P || u.isFetching, onClick: () => {
          D(u.data.version), f("");
        }, children: "Сверил значения — оставить мой выбор" }),
        /* @__PURE__ */ e(g, { disabled: P || u.isFetching, onClick: () => {
          E(null), D(null), f("");
        }, children: "Загрузить сохранённые значения" })
      ] }),
      /* @__PURE__ */ n("form", { onSubmit: (p) => {
        p.preventDefault(), !P && !c && le(u.data, i ?? j.data);
      }, children: [
        /* @__PURE__ */ n("fieldset", { disabled: P || !!c || u.isFetching, children: [
          /* @__PURE__ */ e("legend", { children: "Разрешения владельца" }),
          Ge.map(([p, $]) => /* @__PURE__ */ n("label", { className: "portal-order-policy-choice", children: [
            /* @__PURE__ */ e(
              "input",
              {
                type: "checkbox",
                name: p,
                checked: (i ?? j.data)[p],
                onChange: (v) => M(p, v.target.checked, j.data, u.data.version)
              }
            ),
            $
          ] }, p))
        ] }),
        /* @__PURE__ */ e(g, { type: "submit", variant: "primary", loading: P, disabled: !!c || u.isFetching, children: "Сохранить разрешения" })
      ] })
    ] }) : /* @__PURE__ */ e("p", { role: "status", children: "Эта версия сервера не предоставляет настройку запросов изменения и отмены. Разрешения недоступны." })
  ] }) });
}
function Tr({ api: t, token: l, identity: a }) {
  return /* @__PURE__ */ n("section", { className: "portal-order-policies", children: [
    /* @__PURE__ */ e(Er, { api: t, token: l, identity: a }, a),
    /* @__PURE__ */ e(vr, { api: t, token: l, identity: a })
  ] });
}
function Er({ api: t, token: l, identity: a }) {
  const [u, i] = h(!1), [E, T] = h(null), [D, P] = h(null), [o, c] = h(null), f = G({
    queryKey: ["portal-order-policy", a],
    queryFn: () => Ye(t, l),
    retry: !1,
    staleTime: 0
  }), z = async (S, C) => {
    if (!(u || (o == null ? void 0 : o.kind) === "conflict" || (o == null ? void 0 : o.kind) === "unknown")) {
      i(!0), c(null);
      try {
        await hr(t, l, { version: D ?? S.version, clientHistoryVisible: C }), c({ kind: "saved", attempted: C }), T(null), P(null);
      } catch (N) {
        c({ kind: N instanceof I && N.status === 409 ? "conflict" : "unknown", attempted: C });
      } finally {
        await f.refetch(), i(!1);
      }
    }
  }, F = o !== null && o.kind !== "saved";
  return /* @__PURE__ */ n(Q, { padding: "lg", children: [
    /* @__PURE__ */ e("h2", { children: "История заказов из 1С для клиентов" }),
    /* @__PURE__ */ e("p", { children: "Разрешить клиентам видеть заказы, созданные вне портала, а также импортированную историю с неизвестным происхождением. Доступ остаётся ограничен назначенными точками и плательщиками. На просмотр менеджерами этот флаг не влияет." }),
    F && /* @__PURE__ */ n("p", { role: "alert", children: [
      o.kind === "conflict" ? "Настройка изменилась в другой сессии." : "Результат сохранения не подтверждён.",
      " ",
      "Вы предлагали: ",
      o.attempted ? "показывать историю" : "скрывать историю",
      ".",
      " ",
      "Сверьте значение с сервера перед новой попыткой."
    ] }),
    (o == null ? void 0 : o.kind) === "saved" && /* @__PURE__ */ e("p", { role: "status", children: "Настройка сохранена." }),
    f.isPending ? /* @__PURE__ */ e("p", { role: "status", children: "Проверяем настройку…" }) : f.isError ? /* @__PURE__ */ n(W, { children: [
      /* @__PURE__ */ e(Y, { variant: "danger", body: "Не удалось подтвердить доступ к настройке. Прежнее значение скрыто." }),
      /* @__PURE__ */ e(g, { onClick: () => void f.refetch(), children: "Проверить снова" })
    ] }) : /* @__PURE__ */ n(W, { children: [
      /* @__PURE__ */ n("p", { children: [
        "Сохранённое значение на сервере: ",
        /* @__PURE__ */ e("strong", { children: f.data.clientHistoryVisible ? "история видна клиентам" : "история скрыта от клиентов" }),
        "."
      ] }),
      F && /* @__PURE__ */ e(g, { disabled: u || f.isFetching, onClick: () => {
        P(f.data.version), c(null);
      }, children: "Проверил значение с сервера" }),
      E !== null && /* @__PURE__ */ e(g, { disabled: u || f.isFetching, onClick: () => {
        T(null), P(null), c(null);
      }, children: "Отменить мой выбор истории" }),
      /* @__PURE__ */ e(
        Cr,
        {
          visible: E ?? f.data.clientHistoryVisible,
          onChange: (S) => {
            D === null && P(f.data.version), T(S), c(null);
          },
          pending: u,
          disabled: F || f.isFetching,
          onSave: (S) => void z(f.data, S)
        }
      )
    ] })
  ] });
}
function Cr({ visible: t, onChange: l, pending: a, disabled: u, onSave: i }) {
  return /* @__PURE__ */ n("form", { onSubmit: (E) => {
    E.preventDefault(), !a && !u && i(t);
  }, children: [
    /* @__PURE__ */ n("label", { className: "portal-order-policy-choice", children: [
      /* @__PURE__ */ e(
        "input",
        {
          type: "checkbox",
          name: "clientHistoryVisible",
          checked: t,
          disabled: a || u,
          onChange: (E) => l(E.target.checked)
        }
      ),
      "Клиенты могут видеть историю заказов из 1С"
    ] }),
    /* @__PURE__ */ e(g, { type: "submit", variant: "primary", loading: a, disabled: u, children: "Сохранить настройку истории" })
  ] });
}
export {
  Tr as OrderHistoryPolicy,
  Dr as PortalOrdersWorkspace,
  Or as PrivateQueryWorkspace,
  ze as formatExactDecimal,
  ae as formatExactMoney
};
//# sourceMappingURL=index.js.map
